import styled from "styled-components";
import {colors, sizes, fontSize} from "../../../../themes";

export const PageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${colors.background.white};
`;

export const ContentWrapper = styled.div`
  width: 1080px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 74px;
  @media only screen and ${sizes.max991} {
    width: 90vw;
  }
`;

export const ReservationSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 37px;
  margin-bottom: 20px;
  > div {
    height: 100%;
    padding: 20px 33px;
    background: ${colors.background.white};
    border: 1px solid ${colors.border.concrete};
    border-radius: 8px;
    flex: 535;
    :last-of-type {
      flex: 508;
    }
  }
  @media only screen and ${sizes.max991} {
    flex-direction: column-reverse;
    gap: 7.4vw;
    > div {
      padding: 4vw 6.6vw;
    }
    margin-bottom: 4vw;
  }
`;

export const TermsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: pre-wrap;
  font-style: normal;
  font-weight: 400;
  ${fontSize(14)}
  line-height: 100%;
  color: ${colors.text.ebony};
  margin-bottom: 16px;
  a {
    text-decoration: none;
    font-weight: 700;
    color: ${colors.text.kleinBlue};    
  }
  @media only screen and ${sizes.max991} {
    margin-bottom: 3.2vw;   
    font-size: 2.2vw !important;
  }
`;
